import { render, staticRenderFns } from "./talet_screen.vue?vue&type=template&id=63e1a870&scoped=true"
import script from "./talet_screen.vue?vue&type=script&lang=js"
export * from "./talet_screen.vue?vue&type=script&lang=js"
import style0 from "./talet_screen.vue?vue&type=style&index=0&id=63e1a870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e1a870",
  null
  
)

export default component.exports